import { Input } from '@commenda/kakashi';
import { useFormField } from '../../hooks/useFormField';
import { LabelWithGuidanceTooltip } from './LabelWithGuidanceTooltip';

export const PasswordInputComponent = ({
  fieldId,
  label,
  description,
  placeholder,
  guidance,
  validation,
  props = {},
}: any) => {
  const { value, error, disabled, isRequired, setValue } = useFormField<string>(
    fieldId,
    {
      rules: validation?.rules,
      disabledFromProps: props?.disabled as boolean,
    }
  );

  return (
    <div className="mb-4" data-field-id={fieldId}>
      {(label || description) && (
        <LabelWithGuidanceTooltip
          label={label}
          description={description}
          guidance={guidance?.text}
          isRequired={isRequired}
        />
      )}
      <Input
        type="password"
        value={value || ''}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        error={error}
        disabled={disabled}
      />
    </div>
  );
};
